var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Archive component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconAlignLeft extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#3F3F3F">
          <path
            aria-hidden="${!this.iconTitle}"
            aria-label="${ifDefined(this.iconTitle)}"
            role="${this.iconTitle && 'img'}"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.07265 1.65785C1.90345 1.72292 1.72021 1.90983 1.65423 2.08467C1.58804 2.26006 1.59788 2.52934 1.67602 2.68129C1.78973 2.90235 1.97086 3.04383 2.20304 3.09303C2.38477 3.1315 21.615 3.1315 21.7967 3.09303C22.0289 3.04383 22.21 2.90235 22.3237 2.68129C22.4018 2.52934 22.4117 2.26006 22.3455 2.08467C22.2777 1.90513 22.0963 1.72256 21.9202 1.65665C21.7902 1.608 21.7801 1.60796 11.9929 1.60921C2.29741 1.61045 2.19459 1.61096 2.07265 1.65785ZM2.23707 6.43453C2.00072 6.47417 1.79103 6.62727 1.67492 6.84497C1.62879 6.93147 1.61998 6.98446 1.61993 7.17596C1.61986 7.38356 1.6262 7.41538 1.69057 7.53161C1.77668 7.68704 1.88674 7.78697 2.06276 7.86953L2.19586 7.93196L9.49186 7.93877C14.6907 7.94362 16.8322 7.93805 16.942 7.91936C17.2082 7.87405 17.3955 7.7288 17.5094 7.47951C17.5666 7.35449 17.5724 7.31756 17.5629 7.14351C17.5459 6.83403 17.3981 6.61604 17.1154 6.48351L16.9799 6.41996L9.67186 6.4166C5.5201 6.4147 2.30909 6.42245 2.23707 6.43453ZM2.22709 11.2564C1.99801 11.2954 1.78928 11.4556 1.66486 11.688C1.60061 11.8079 1.60061 12.192 1.66486 12.312C1.75688 12.4838 1.87093 12.5965 2.03398 12.6768L2.19485 12.756H7.17536H12.1559L12.2999 12.6887C12.5875 12.5544 12.7481 12.3076 12.7481 12C12.7481 11.6923 12.5875 11.4455 12.2999 11.3112L12.1559 11.244L7.24786 11.2406C4.54846 11.2387 2.2891 11.2459 2.22709 11.2564ZM2.21612 16.0809C1.99496 16.1247 1.80221 16.2667 1.69057 16.4683C1.6262 16.5845 1.61986 16.6164 1.61993 16.824C1.62001 17.0851 1.65963 17.1877 1.82386 17.352C1.94681 17.4749 2.07121 17.5363 2.25896 17.5668C2.47167 17.6013 16.7041 17.6013 16.9168 17.5668C17.1045 17.5363 17.2289 17.4749 17.3519 17.352C17.4979 17.2059 17.5505 17.0825 17.5629 16.8564C17.5724 16.6824 17.5666 16.6454 17.5094 16.5204C17.398 16.2766 17.2125 16.1294 16.957 16.0822C16.7866 16.0507 2.37519 16.0495 2.21612 16.0809ZM2.17186 20.9135C1.84743 20.9932 1.63333 21.2564 1.61353 21.6C1.60529 21.7432 1.6136 21.8076 1.65423 21.9152C1.72198 22.0948 1.90337 22.2774 2.07949 22.3433C2.20952 22.3919 2.22116 22.392 11.9999 22.392C21.7786 22.392 21.7902 22.3919 21.9202 22.3433C22.0963 22.2774 22.2777 22.0948 22.3455 21.9152C22.4117 21.7399 22.4018 21.4706 22.3237 21.3186C22.21 21.0976 22.0289 20.9561 21.7967 20.9069C21.6044 20.8662 2.33816 20.8727 2.17186 20.9135Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconAlignLeft.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconAlignLeft.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconAlignLeft.prototype, "size", void 0);
if (customElements.get('cat-icon-align-left') === undefined) {
    customElements.define('cat-icon-align-left', BlocksIconAlignLeft);
}
